import { render, staticRenderFns } from "./MediaSearchSightingsTable.vue?vue&type=template&id=2137325a&scoped=true"
import script from "./MediaSearchSightingsTable.vue?vue&type=script&lang=js"
export * from "./MediaSearchSightingsTable.vue?vue&type=script&lang=js"
import style0 from "./MediaSearchSightingsTable.vue?vue&type=style&index=0&id=2137325a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137325a",
  null
  
)

export default component.exports